import { useMemo } from 'react'

import type { FormSectionProps } from '@/components/inputs/types'
import { getCustomsBrokerLocationContext } from '@/utils/shipmentFuncs'

import { useBookingFormCtx } from '../book/BookingFormProvider'
import { useCarrierBookingFormSettings } from '../book/bookFuncs'
import { ShipmentFormSection } from '../shipment-form/ShipmentFormSection'
import { CustomsBrokerForm } from './CustomsBrokerForm'

export const LTLBroker = ({ disabled }: FormSectionProps) => {
  const { setBrokerValues } = useBookingFormCtx(s => s.actions)
  const broker = useBookingFormCtx(s => s.customsBroker)
  const locations = useBookingFormCtx(s => s.locations)
  const { required, location } = useMemo(
    () => getCustomsBrokerLocationContext(locations),
    [locations],
  )
  const requireValue =
    useCarrierBookingFormSettings()?.requireCustomsBrokerValue

  if (!location) return null
  return (
    <ShipmentFormSection
      title="Customs broker"
      className="gray-container"
      pillClassName="default-container !border-2"
    >
      <div className="form-row grid grid-cols-4">
        <CustomsBrokerForm
          workflow="ltl"
          loadLocation={location}
          locations={locations}
          disabled={disabled}
          required={required}
          setValues={setBrokerValues}
          values={broker}
          requireValue={requireValue}
        />
      </div>
    </ShipmentFormSection>
  )
}
